<template>
    <IPopupMenu
        v-if="languageItems?.length??0 > 0"
        trigger="click"
    >
        <template v-slot:trigger>
            <a :class="triggerClass" v-tooltip.bottom="trans('dashboard.menu.tooltip.language_switch')">
                <IMDI icon="web" />
                <span :class="'mt-1 fi fi-' + (languageCurrent.flag??languageCurrent.language)"></span>
            </a>
        </template>
        <template v-slot:items>
            <template v-for="item in languageItems"
                      v-bind:key="item.language"
            >
                <li @click="switchLanguage(item.language)"
                    v-tooltip.bottom="item.tooltip"
                >
                    <span :class="'fi fi-' + (item.flag??item.language)"></span>
                    <span class="langtext">{{ trans('language.' + item.language) }}</span>
                </li>
            </template>
            <li v-if="showMoreLanguages" 
                @click="navigateTo(route('backend.config.general.index') + '?tab=5&action=web')">
                <span class="langtext"><i>{{ trans('dashboard.menu.label.more_languages') }}</i></span>
            </li>
        </template>
    </IPopupMenu>
</template>

<script setup>
import { inject, nextTick, onMounted, ref } from 'vue';
import { router } from '@inertiajs/vue3';
import { getLocale, setLocale } from 'matice';
import { handleErrors, navigateTo } from '@/integeri-helper.js';
import IPopupMenu from '@/Components/Common/IPopupMenu.vue';
import api from '@/api';

const route = inject('route');
const emitter = inject('emitter');
const languageItems = ref(null);
const languageCurrent = ref({flag:'de'});
const loadingLangs = ref(false);

defineProps({
    triggerClass: {
        type: String,
        required: false,
        default: '',
    },
    showMoreLanguages: {
        type: Boolean,
        required: false,
        default: false,
    },
});
emitter.on('popupmenu:opened', async () => {
    emitter.emit('popupmenu:move', [100, 100]);
});
emitter.on('languagemenu:update', () => {
    loadLanguages();
});
const switchLanguage = (lang) => {
    // document.cookie = `lang=${lang};path=/;max-age=31536000`;
    // const currentPath = routerRoute.path;
    // let newPath = currentPath.replace(/lang=\w\w/, 'lang=' + lang);
    // if (newPath.indexOf('lang=') == -1) {
    //     newPath = newPath + '?lang=' + lang;
    // }
    // // Preserve query parameters and hash
    // const query = routerRoute.query;
    // const hash = routerRoute.hash;
    // router.push({ path: newPath, query, hash });
    // // // setLocale(lang);
    // // // languageNew.value = lang;
    setLocale(lang);
    // // languageNew.value = lang;

    nextTick(() => {
        const x = document.location.href.split('?');
        let params = 'lang=' + lang;
        if (x.length > 1) {
            const rest = x[1].replace(/lang=\w\w/, '');
            if (rest.length > 0) {
                params = rest + '&' + params;
            }
        }
        const newPath = x[0] + '?' + params;
        router.push({ path: newPath });
        nextTick(() => {
            window.location.href = newPath;
        });
    });
};
const loadLanguages = () => {
    if (!loadingLangs.value) {
        loadingLangs.value = true;
        api.get(
            route('ajax.get-languages', {
                _t: Date.now(),
            }),
        ).then((response) => {
            languageItems.value = response.languages;
            languageCurrent.value = response.languages.filter((x) => x.language ==  getLocale())[0]??null;
        }).catch((e) => {
            handleErrors(e);
        }).finally(() => {
            loadingLangs.value = false;
        });
    }
};
onMounted(() => {
    if ((languageItems.value??null) == null) {
        loadLanguages();
    }
});
</script>

<style lang="scss">
#popup_menu_container:has(.mdi-web) {
    align-content: center;

    & .menu_trigger {
        font-size: 18pt;
    }
    & .popup_menu {
        width: 150px;
        left: calc(100% - 150px - 180px);
        &.mobile {
            left: calc(100% - 150px - 80px);
        }
        & li {
            padding: 5px;

            & .langtext {
                margin-left: 5px;
            }
        }
    }
    &:has(.login) {
        & .popup_menu {
            left: calc(100% - 200px);
        }
    }
}
</style>
<style lang="scss" scoped>
a:has(.fi) {
    width: 69px;
    gap:4px;
}
a {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: var(--app-color-default);
    text-decoration: none;
    border-radius: 100px;
    transition: 0.15s ease-in-out all;

    & .fi {
        display:inline-block;
        width: 30px;
        height: 21px;
    }

    &.active {
        background: var(--app-color-blue);
        color: var(--app-color-white);
    }

    &:hover {
        background: var(--app-color-blue-background);
        color: var(--app-color-blue);
    }
}
</style>
